export default __webpack_public_path__ + "static/media/ms-excel-icon.dc0548b1.svg";